import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-pqrs',
  templateUrl: './footer-pqrs.component.html',
  styleUrls: ['./footer-pqrs.component.scss']
})
export class FooterPqrsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
